var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import template from './../../html/chat.html';
import { WidgetUIController } from '../widgetUIController/widgetUIController';
import CachingService from '../caching/cachingService';
import ChatBotParser from '../parser/chatBotParser';
import { ElementRenderer } from '../renderer/elementRenderer';
import { TNPSSurvey } from '../utils/tnpsSurvey';
import { SecureKeyNotice } from '../customNotice/botNotice/secureKeyNotice';
import { UserMessageNotice } from '../customNotice/clientNotice/userMessageNotice';
import { RequestExecutionRightsNotice } from '../customNotice/clientNotice/requestExecutionRightsNotice';
import { ScreenChangeNotice } from '../customNotice/clientNotice/screenChangeNotice';
import { MessageEvent } from '../events/botEvents/messageEvent';
import { WaitingTimeEvent } from '../events/botEvents/waitingTimeEvent';
import { TNPSSurveyEvent } from '../events/botEvents/tnpsSurveyEvent';
import { FeedbackOfferDataEvent } from '../events/botEvents/feedbackOfferDataEvent';
import { UsecaseDataEvent } from '../events/botEvents/usecaseDataEvent';
import { HandoverStatusEvent } from '../events/botEvents/handoverStatusEvent';
import { FeedbackOfferNotice } from '../customNotice/botNotice/feedbackOfferNotice';
import { DebugInfoEvent } from '../events/botEvents/debugInfoEvent';
import { PauseEvent } from '../events/botEvents/pauseEvent';
import { isInApp } from '../utils/isInApp';
import { AddressCheckEvent } from '../events/botEvents/addressCheckEvent';
import { ExtensionNotice } from '../customNotice/clientNotice/extensionNotice';
import { TrackingNotice } from '../customNotice/botNotice/trackingNotice';
import { ShowScreenEvent } from '../events/botEvents/showScreenEvent';
import { ChannelSettingsEvent } from '../events/botEvents/channelSettingsEvent';
import { ChannelSettingsHandler } from './channelSettingsHandler';
import { FileLimitsHelper } from '../utils/fileLimitsHelper';
export class WidgetApplication {
    constructor(name, msgBus, bridge) {
        this.id = Math.random().toString().replace("0.", "");
        // map of callback functions that are called if requestExecutionrightsnotice is successfull
        this.callbackMap = {};
        // determines the time until next message will be shown
        this.pauseEnd = 0;
        // queue for bot interactions
        this.handleBotInteractionsQueue = [];
        // list of callback function to call when chat was restored
        this.restoreCallbacks = [];
        /**
         * Function is used to append the rendered template to the provided parent dic and initialize the widget ui controller
         * by registering all relevant ui elements and event handlers
         * @param {*} parent the html div the widget should be appended to
         */
        this.bootstrapWidgetHtml = (parent) => {
            let div = document.createElement('div');
            div.innerHTML = template;
            let wrapperdiv = parent.appendChild(div);
            this.uic.initializeUI(wrapperdiv, this, this.configuration);
        };
        /**
         * @returns a promise with a value that indicates if the chat session is healthy
         */
        this.isHealthyChatSession = () => {
            return new Promise((resolve, reject) => {
                // we need to start the chat ourselves if it can't be restored
                setTimeout(() => {
                    if (!this.intObj) {
                        resolve(false);
                    }
                    else {
                        resolve(true);
                    }
                }, 2000);
            });
        };
        /**
        * ACHTUNG: FUNKTION WURDE AM MESSAGE BUS REGISTRIERT, WIRD IM CONTEXT DES PLUGINS AUFGERUFEN
        * @param {*} arguments
        */
        this.open = (arg) => {
            this.debug ? console.log("#############OPEN###########") : () => { };
            this.debug ? console.log(arg) : () => { };
            let options = arg;
            if (options.custom && options.custom.channelEntry) {
                this.defaultChannelEntry = options.custom.channelEntry;
            }
            if (options.new_question) {
                this.startChat().then(() => {
                    this.msgBus.publish('opened');
                });
                return;
            }
            this.handleEvents = true;
            // wait for preconditions tobe fullfilled
            this.bridge.Helpers.wait(() => {
                return !!this.configuration && !!this.intObj && !!this.widgetInitialized;
            }).then(() => {
                if (this.state.mode != 'sticky') {
                    this.cachingService.resetUserInformation();
                    this.cachingService.saveUserInformation(options);
                }
                if (options.noicons) {
                    this.state.hideIcons = true;
                }
                else if (isInApp()) {
                    this.state.hideIcons = true;
                }
                else {
                    this.state.hideIcons = false;
                }
                if (!this.uic.isInitialized()) {
                    this.bootstrapWidgetHtml(document.body);
                }
                if (options.anon) {
                    this.track("chat", "chat_start", "auto");
                    this.state.mode = "autoOpen";
                    this.activateChat(false);
                }
                else if (options.login) {
                    this.track("chat", "chat_loaded", "login_form");
                    this.state.mode = "button";
                    this.activateChat(true);
                }
                else if (options.login === false && options.stickyStart) {
                    this.track("chat", "chat_loaded", "sticky");
                    this.state.mode = "button";
                    this.activateChat(false);
                }
                else if (options.login === false) {
                    this.state.mode = "button";
                    this.track("chat", "chat_start", "button");
                    this.activateChat(false);
                }
                else if (this.state.mode == "sticky") {
                    this.track("chat", "chat_start", "sticky");
                    this.activateChat(false);
                }
                else if (this.state.mode == 'autoOpen') {
                    this.uic.stickyManager.hideSticky(undefined);
                }
                else if (!options.sticky) {
                    // Widget not in sticky mode 
                    this.state.mode = "button";
                    this.activateChat(true);
                }
                else {
                    this.track("chat", "chat_loaded", "sticky");
                    this.state.mode = "sticky";
                    this.uic.stickyManager.setSticky();
                }
            });
        };
        /**
         * ACHTUNG: FUNKTION WURDE AM MESSAGE BUS REGISTRIERT, WIRD IM CONTEXT DES PLUGINS AUFGERUFEN
         * @param {*} arguments
         */
        this.close = (arg) => {
            this.debug ? console.log("#############CLOSE###########") : () => { };
            this.debug ? console.log(arg) : () => { };
            if (this.state.mode == 'sticky') {
                if (this.uic.isInitialized()) {
                    this.uic.resetSticky();
                }
                this.state.softReset();
                this.cachingService.softReset();
                this.cachingService.resetUserInformation();
                this.cachingService.saveCacheSession(this.state);
            }
            else if (this.state.mode == 'autoOpen') {
                if (this.uic.isInitialized()) {
                    this.uic.reset();
                }
            }
            else {
                this.state.reset();
                if (this.uic.isInitialized()) {
                    this.uic.reset();
                }
                this.cachingService.softReset();
                this.cachingService.resetUserInformation();
                this.cachingService.saveCacheSession(this.state);
            }
            this.msgBus.publish('closed');
        };
        /**
         * Ends active chat session
         *
         * @param promise optional paramater, chat will only technically be ended when this promise is fullfilled
         *
         * @returns promise that is fullfilled when chat session is closed
         */
        this.endChatSession = (promise) => {
            return new Promise((resolve, reject) => {
                this.debug ? console.log("END CHAT WAS CALLED") : () => { };
                this.displayCollectedMessages();
                this.uic.endChatSession();
                if (promise) {
                    promise.then(() => {
                        this.endChat().then(() => {
                            resolve();
                        });
                    });
                }
                else {
                    this.endChat().then(() => {
                        resolve();
                    });
                }
            });
        };
        /**
         * Resets an active chat session. Differs from endChatSession in the way
         * that it also closes the widget
         *
         * @param withReload if true reloads the page after chat session was ended
         */
        this.resetChatSession = (withReload) => {
            return new Promise((resolve, reject) => {
                this.endChat().then(() => {
                    // for some reason we need this timeout. The promise does not seem to be fully finished at this point
                    setTimeout(() => {
                        if (withReload) {
                            window.location.reload();
                        }
                        else {
                            this.close();
                        }
                        resolve();
                    }, 200);
                }).catch((error) => {
                    // for some reason we need this timeout. The promise does not seem to be fully finished at this point
                    setTimeout(() => {
                        if (withReload) {
                            window.location.reload();
                        }
                        else {
                            this.close();
                        }
                        resolve();
                    }, 200);
                });
            });
        };
        /**
         * Restores an active chat session
         */
        this.restoreChatSession = () => {
            this.debug ? console.log("Restore Chat Session") : () => { };
            if (this.cachingService.isNewCache) {
                console.error("Storage for restored chat not available. End Chat Session");
                this.resetChatSession(false);
                return;
            }
            else {
                if (!this.state.screen) {
                    this.resetChatSession(false);
                    return;
                }
            }
            if (isInApp()) {
                this.state.hideIcons = true;
            }
            else {
                this.state.hideIcons = false;
            }
            if (!this.uic.isInitialized()) {
                this.bootstrapWidgetHtml(document.body);
            }
            this.activeSession = true;
            if (this.state.mode == 'autoOpen') {
                this.uic.stickyManager.showSticky(undefined);
            }
            this.uic.activateChat();
            if (this.state.botConnected) {
                this.uic.activateBotView();
                this.uic.setActiveContainer(true);
            }
            else if (this.state.agentConnected) {
                this.uic.chatScreen.showBotConversationOverlay();
                this.uic.setActiveContainer(false);
            }
            this.showChatHistory();
            this.uic.showScreen(this.state.screen);
            this.msgBus.publish('opened');
            this.restoreCallbacks.forEach((callback) => {
                callback();
            });
        };
        /**
         * Shows chat history stored in the cache
         */
        this.showChatHistory = () => {
            this.uic.stickyManager.setRestoreChat(true);
            let botContainer = this.cachingService.botMessageContainer;
            for (let message of botContainer) {
                this.uic.appendBotTextToChatbox(message);
            }
            let agentContainer = this.cachingService.agentMessageContainer;
            for (let message of agentContainer) {
                this.uic.appendAgentTextToChatbox(message);
            }
            this.uic.stickyManager.setRestoreChat(false);
        };
        /**
         * Send text message to connected system
         *
         * @param text string to send
         * @param displayedText to the user
         */
        this.sendUserMessage = (text, displayedText) => {
            this.intObj.sendMessage(text);
            // reset feedback offer local after each message from the user
            this.state.feedbackOfferLocal = true;
            if (displayedText !== undefined && displayedText !== null) {
                text = displayedText;
            }
            if (text) {
                this.showUserMessage(text, true);
            }
            else {
                if (this.state.botConnected) {
                    this.uic.chatScreen.showTyping('bot');
                }
            }
        };
        /**
        * ACHTUNG: FUNKTION WURDE AM MESSAGE BUS REGISTRIERT, WIRD IM CONTEXT DES PLUGINS AUFGERUFEN
        * @param {*} arguments
        */
        this.handleBotInteractions = (arg, arg2) => {
            this.bridge.Helpers.wait(() => {
                return !!this.configuration && !!this.intObj && !!this.widgetInitialized;
            }).then(() => __awaiter(this, void 0, void 0, function* () {
                yield this.waitForOthersToFinish();
                this.debug ? console.log("#############EVENT###########") : () => { };
                this.debug ? console.log(arg) : () => { };
                this.debug ? console.log(arg2) : () => { };
                let eventObject = arg2;
                if (eventObject.hasOwnProperty('event') && this.handleEvents) {
                    let command = eventObject['event'];
                    // Handling for all events that are coming in from the chatbot
                    switch (command) {
                        case 'WebChatService.messageReceived':
                            let endChatSession = false;
                            let showBotMessageLeft = false;
                            let botWasConnected = this.state.botConnected;
                            let sessionData = eventObject.data.sessionData ? eventObject.data.sessionData : this.sessionData;
                            let elementRenderer = new ElementRenderer(this.configuration);
                            for (let message of eventObject.data.originalMessages) {
                                yield this.pause();
                                if (this.cachingService.indexList.includes(message.index)) {
                                    // ignore messages that we already processed
                                    continue;
                                }
                                this.parser.parseWebChatServiceMessage(message, elementRenderer, this);
                                this.cachingService.indexList.push(message.index);
                                let type = message.type;
                                let senderType = this.parser.getMessageSenderType(message);
                                switch (type) {
                                    case 'Message':
                                        switch (senderType) {
                                            case 'agent':
                                                break;
                                            case 'bot':
                                                let structuredContent = this.parser.parseStructuredContent(message);
                                                if (structuredContent) {
                                                    this.handleBotEvents(structuredContent);
                                                }
                                                break;
                                            case 'client':
                                            case 'system':
                                                break;
                                        }
                                        break;
                                    case 'ParticipantJoined':
                                        switch (senderType) {
                                            case 'agent':
                                                if (!this.state.botWasConnected) {
                                                    this.track("chat", "chat_started", "agent_joined");
                                                }
                                                this.debug ? console.log("AGENT joined the chat") : () => { };
                                                this.state.agentConnected = true;
                                                this.uic.setActiveContainer(false);
                                                this.displayCollectedMessages();
                                                this.uic.chatScreen.showBotConversationOverlay();
                                                this.showAgentJoinedMessage(message.from.nickname);
                                                this.uic.showScreen('chat');
                                                break;
                                            case 'bot':
                                                this.track("chat", "chat_started", "bot_joined");
                                                this.debug ? console.log("BOT joined the chat") : () => { };
                                                this.uic.setActiveContainer(true);
                                                if (this.sessionData) {
                                                    this.sendSessionDataAsNotice(sessionData);
                                                    if (this.sessionData.sessionID) {
                                                        this.cachingService.interactionId = sessionData.sessionID;
                                                    }
                                                    if (typeof this.cachingService.sessionId !== 'string') {
                                                        this.cachingService.sessionId = sessionData.sessionID;
                                                    }
                                                }
                                                this.state.botConnected = true;
                                                this.state.agentConnected = true;
                                                this.displayCollectedMessages();
                                                this.showBotJoinedMessage();
                                                this.uic.activateBotView();
                                                break;
                                            case 'system':
                                                // ignore for now
                                                break;
                                        }
                                        break;
                                    case 'ParticipantLeft':
                                        switch (senderType) {
                                            case 'agent':
                                                this.debug ? console.log("AGENT left the chat") : () => { };
                                                this.showAgentLeftMessage(message.from.nickname);
                                                break;
                                            case 'bot':
                                                this.debug ? console.log("BOT left the chat") : () => { };
                                                // bot left event potentially is received before messages from bot, we remember to show the message
                                                showBotMessageLeft = true;
                                                this.uic.setActiveContainer(false);
                                                this.state.agentConnected = false;
                                                this.state.botConnected = false;
                                                this.uic.deactivateBotView();
                                                this.uic.chatScreen.hideTyping();
                                                // switch to waiting screen after 5 seconds
                                                this.uic.transferToWaitingScreen(5);
                                                break;
                                            case 'client':
                                                // after messages were processed, end chat session
                                                endChatSession = true;
                                            case 'system':
                                                // ignore for now
                                                break;
                                        }
                                        break;
                                    case 'TypingStarted':
                                        if (senderType == "bot" || senderType == 'agent') {
                                            this.uic.chatScreen.showTyping(senderType);
                                        }
                                        break;
                                    case 'TypingStopped':
                                        if (senderType == "bot" || senderType == 'agent') {
                                            this.uic.chatScreen.hideTyping();
                                        }
                                        break;
                                    case 'FileUploaded':
                                        break;
                                    case 'PushUrl':
                                        break;
                                    case 'External':
                                        break;
                                    case 'CustomNotice':
                                        switch (senderType) {
                                            case 'agent':
                                                break;
                                            case 'bot':
                                                break;
                                            case 'client':
                                                this.handleClientNotice(message.text);
                                                break;
                                            case 'system':
                                                break;
                                        }
                                        break;
                                }
                                if (this.state.botConnected || botWasConnected) {
                                    this.uic.appendMessageToBotContainer(elementRenderer.getCurrentMessage(), elementRenderer.getCurrentUser());
                                }
                                else if (this.state.agentConnected) {
                                    this.uic.appendMessageToAgentContainer(elementRenderer.getCurrentMessage(), elementRenderer.getCurrentUser());
                                }
                            }
                            let html = elementRenderer.getResult();
                            if (html) {
                                if (this.state.botConnected || botWasConnected) {
                                    this.cachingService.botMessageContainer.push(html);
                                }
                                else if (this.state.agentConnected) {
                                    this.cachingService.agentMessageContainer.push(html);
                                }
                                else {
                                    // system messages without a connected agent get collected
                                    this.messageCollector.push(html);
                                }
                            }
                            if (endChatSession) {
                                this.endChatSession();
                            }
                            if (showBotMessageLeft) {
                                this.showBotLeftMessage();
                            }
                            this.cachingService.saveCacheSession(this.state);
                            break;
                        case 'WebChatService.started':
                            break;
                        case 'WebChatService.agentConnected':
                            break;
                        case 'WebChatService.agentDisconnected':
                            break;
                        case 'WebChatService.reconnected':
                            this.debug ? console.log("WEBCHATSERVICE RECONNECTED") : () => { };
                            this.uic.chatReconnected();
                            break;
                        case 'WebChatService.disconnected':
                            this.debug ? console.log("WEBCHATSERVICE DISCONNECTED") : () => { };
                            this.uic.chatDisconnected();
                            break;
                        case 'WebChatService.restored':
                            if (!this.restored) {
                                this.restored = true;
                                this.restoreChatSession();
                            }
                            break;
                        case 'WebChatService.ended':
                            break;
                        case 'WebChatService.data':
                            if (!!eventObject['data'] && !!eventObject['data']['userData']
                                && eventObject['data']['userData']['value']
                                && Object.keys(eventObject['data']['userData']['value']).length !== 0) {
                                this.cachingService.userData = eventObject['data']['userData'];
                                this.debug ? console.debug("USERDATA WAS SET") : () => { };
                            }
                            if (eventObject['data'] && eventObject['data']['sessionActive'] &&
                                !eventObject['data']['sessionActive']['value'] &&
                                eventObject['data']['sessionActive']['last'] === false &&
                                this.activeChatSession()) {
                                this.track("chat", "chat_ended", "finished");
                                this.endChatSession();
                            }
                            break;
                        case 'WebChatService.data.WebChatService.sessionData':
                            if (!!eventObject['data'] && !!eventObject['data']['value']) {
                                this.sessionData = eventObject['data']['value'];
                                if (this.sessionData.sessionID) {
                                    this.cachingService.interactionId = this.sessionData.sessionID;
                                }
                                if (this.state.botConnected) {
                                    this.sendSessionDataAsNotice(this.sessionData);
                                }
                                this.debug ? console.debug("SESSIONDATA WAS SET") : () => { };
                            }
                            break;
                        case 'WebChatService.clientConnected':
                            break;
                        case 'WebChatService.clientDisconnected':
                            break;
                        case 'WebChatService.restoreTimeout':
                            break;
                        case 'WebChatService.error':
                            // on error end chat session
                            this.doErrorHandling(eventObject);
                            break;
                        default:
                            break;
                    }
                    this.cachingService.saveCacheSession(this.state);
                }
                this.handleBotInteractionsQueue.shift();
            }));
        };
        /**
         * Handle messages and events from bot
         *
         * @param structuredContent object that contains structured content from the bot
         */
        this.handleBotEvents = (botEvent) => {
            if (botEvent.type === MessageEvent.getType()) {
                let messageEvent = botEvent;
                if (messageEvent.gdpr == false) {
                    this.uic.showScreen('gdpr');
                }
                else if (messageEvent.gdpr == true) {
                    this.uic.showScreen('chat');
                }
            }
            else if (botEvent.type === WaitingTimeEvent.getType()) {
                let waitingTimeEvent = botEvent;
                this.cachingService.waitingTime = waitingTimeEvent.ewt;
            }
            else if (botEvent.type === FeedbackOfferDataEvent.getType()) {
                let feedbackOfferDataEvent = botEvent;
                this.state.feedbackOfferGlobal = feedbackOfferDataEvent.feedbackOfferGlobal;
                this.state.feedbackOfferLocal = feedbackOfferDataEvent.feedbackOfferLocal;
            }
            else if (botEvent.type === UsecaseDataEvent.getType()) {
                let usecaseDataEvent = botEvent;
                if (!this.cachingService.surveyData) {
                    this.cachingService.surveyData = {};
                }
                this.cachingService.surveyData.usecase = usecaseDataEvent.usecase;
            }
            else if (botEvent.type === HandoverStatusEvent.getType()) {
                let handoverStatusEvent = botEvent;
                this.state.handoverAvailable = handoverStatusEvent.chatOpen;
                this.state.handoverStatusRequestFinished = true;
            }
            else if (botEvent.type === AddressCheckEvent.getType()) {
                this.state.setScreenProperty("chat", "showAddressCheck", true);
                this.uic.activateExtension("addressCheck");
            }
            else if (botEvent.type === TNPSSurveyEvent.getType()) {
                let tnpsSurveyEvent = botEvent;
                if (this.configuration.surveySettings) {
                    if (tnpsSurveyEvent.show) {
                        this.uic.chatScreen.loadingAnimation();
                        let tnpsCallback = () => {
                            let config = {
                                apiUrl: this.configuration.surveySettings.surveyEndpoint,
                                surveyId: this.configuration.surveySettings.surveyId,
                                useProbability: this.configuration.surveySettings.useProbability,
                                usecase: tnpsSurveyEvent.usecase,
                                entrychannel: tnpsSurveyEvent.entrychannel,
                                feedback: tnpsSurveyEvent.feedback,
                                sessionId: this.cachingService.sessionId
                            };
                            this.createNewTNPSSurvey(config, true);
                        };
                        let requestExecutionRightsNotice = new RequestExecutionRightsNotice(this.getWidgetApplicationId(), 'tnpsSurvey');
                        this.callbackMap[requestExecutionRightsNotice.callbackId] = tnpsCallback;
                        this.sendCustomNotice(requestExecutionRightsNotice);
                    }
                    else {
                        let requestExecutionRightsNotice = new RequestExecutionRightsNotice(this.getWidgetApplicationId(), 'thankYou');
                        this.callbackMap[requestExecutionRightsNotice.callbackId] = () => {
                            this.sendCustomNotice(new TrackingNotice("chat", "TNPS_Disabled", "TNPS_Disabled"));
                            this.sendCustomNotice(new ScreenChangeNotice("thankyou"));
                        };
                        this.sendCustomNotice(requestExecutionRightsNotice);
                    }
                }
            }
            else if (botEvent.type === DebugInfoEvent.getType()) {
                if (this.uic.widgetConsole) {
                    let debugInfoEvent = botEvent;
                    this.uic.widgetConsole.fillData(debugInfoEvent.sessionId, debugInfoEvent.userId, debugInfoEvent.conversationId, debugInfoEvent.instanceId);
                }
            }
            else if (botEvent.type === PauseEvent.getType()) {
                let pauseEvent = botEvent;
                this.pauseEnd = Date.now() + pauseEvent.time;
                if (pauseEvent.typing) {
                    if (pauseEvent.time > 500) {
                        setTimeout(() => {
                            // add delay to keep it more natural and less robotic
                            this.uic.chatScreen.showTyping('bot');
                        }, 500);
                    }
                    else {
                        this.uic.chatScreen.showTyping('bot');
                    }
                }
            }
            else if (botEvent.type === ShowScreenEvent.getType()) {
                let showScreenEvent = botEvent;
                this.uic.showScreen(showScreenEvent.screenType, showScreenEvent.options);
            }
            else if (botEvent.type === ChannelSettingsEvent.getType()) {
                let channelSettingsEvent = botEvent;
                let channelSettingsHandler = new ChannelSettingsHandler();
                channelSettingsHandler.handle(channelSettingsEvent, this);
            }
        };
        /**
         * Displays collected messages that could not be assigned to a agent or bot container
         */
        this.displayCollectedMessages = () => {
            for (let message of this.messageCollector) {
                if (this.state.botConnected) {
                    this.uic.appendBotTextToChatbox(message);
                    this.cachingService.botMessageContainer.push(message);
                }
                else {
                    this.uic.appendAgentTextToChatbox(message);
                    this.cachingService.agentMessageContainer.push(message);
                }
            }
            this.messageCollector = [];
            this.cachingService.saveCacheSession(this.state);
        };
        /**
         * Activates a chat session
         */
        this.activateChat = (loginScreen) => {
            this.cachingService.softReset();
            this.state.softReset();
            this.uic.activateChat();
            this.uic.chatScreen.showInputPlaceholder();
            if (loginScreen) {
                this.uic.showScreen("login", "unknown");
            }
            else {
                if (this.configuration.enableAnonymOnboarding) {
                    this.uic.showScreen("splash");
                    this.autoLogin();
                }
                else {
                    this.uic.showScreen("login", "bot");
                }
            }
            this.msgBus.publish('opened');
            this.cachingService.saveCacheSession(this.state);
        };
        /**
         * Starts a chat without login form needed
         */
        this.autoLogin = () => {
            if (!this.cachingService.firstname)
                this.cachingService.firstname = "Anonymous";
            if (!this.cachingService.lastname)
                this.cachingService.lastname = "Anonymous";
            this.startChat();
        };
        /**
         * Starts a chat session
         */
        this.startChat = (optionalUserData, contextString) => {
            return new Promise((resolve, reject) => {
                this.bridge.Helpers.wait(() => {
                    return !!this.intObj && !!this.configuration && !!this.widgetInitialized;
                })
                    .then(() => {
                    let userData = {};
                    if (this.cachingService.sessionId) {
                        this.addDefaultUserData({ cSInteractionId: this.cachingService.sessionId });
                    }
                    for (var k in this.defaultUserData)
                        userData[k] = this.defaultUserData[k];
                    if (optionalUserData) {
                        for (var k in optionalUserData)
                            userData[k] = optionalUserData[k];
                    }
                    let chatStartData = {
                        firstname: this.cachingService.firstname,
                        lastname: this.cachingService.lastname,
                        email: this.cachingService.email,
                        userData: userData
                    };
                    let chatStart = () => {
                        this.intObj.startChat(chatStartData)
                            .then(() => {
                            this.track("chat", "chat_started", "waiting_for_agent");
                            this.saveChatStartTimestamp();
                            this.handleEvents = true;
                            this.debug ? console.log("Chatbot - chat started") : () => { };
                            // Add this line after bug is fixed - KARA-4738
                            //this.uic.chatScreen.setUploadAccept(this.intObj.getFileLimits().accept());
                            this.activeSession = true;
                            // we set to waitng screen in case of reload
                            if (this.state.screen == 'login') {
                                this.state.screen = 'waiting';
                            }
                            // we wait for 10 seconds, if nobody connected, we show waiting screen
                            setTimeout(() => {
                                if (!this.state.agentConnected && this.activeSession) {
                                    this.uic.showScreen("waiting");
                                }
                            }, 10000);
                            this.cachingService.saveCacheSession(this.state);
                            this.msgBus.publish('opened');
                            resolve();
                        }).catch(() => {
                            this.track("chat", "chat_start", "error");
                            console.error("!!!!!!!!!!!!!!!!!!!!!ERROR!!!!!!!!!!!!!!!!!!!!!!!!");
                            console.error("CHAT START");
                            this.resetChatSession(false);
                            reject();
                        });
                    };
                    if (contextString) {
                        this.msgBus.command('InteractionContext.setActiveContext', contextString).then(() => {
                            chatStart();
                        }).catch(() => {
                            this.track("chat", "chat_start", "error");
                            console.error("!!!!!!!!!!!!!!!!!!!!!ERROR!!!!!!!!!!!!!!!!!!!!!!!!");
                            console.error("CHAT START");
                            this.resetChatSession(false);
                            reject();
                        });
                    }
                    else {
                        chatStart();
                    }
                });
            });
        };
        /**
         * Adds a user/client message to the active container
         *
         * @param htmlObject the user message that was converted to a html object
         */
        this.addUserMessageToActiveContainer = (htmlObject) => {
            if (this.state.botConnected) {
                this.uic.chatScreen.appendUserTextToChatbox(htmlObject);
                this.cachingService.botMessageContainer.push(htmlObject);
            }
            else {
                this.uic.chatScreen.appendUserTextToChatbox(htmlObject);
                this.cachingService.agentMessageContainer.push(htmlObject);
            }
        };
        /**
         * @returns true if a chat session is still open
         */
        this.activeChatSession = () => {
            return this.activeSession;
        };
        /**
         * Handles error messages from genesys and acts on it
         *
         * @param eventObject the error object
         */
        this.doErrorHandling = (eventObject) => {
            // Check if error message object exists 
            if (eventObject && eventObject.data && eventObject.data.responseJSON && eventObject.data.responseJSON.errors) {
                let errorList = eventObject.data.responseJSON.errors;
                if (errorList instanceof Array) {
                    for (let error of errorList) {
                        // invalid email error
                        if (error.code == 364) {
                            this.msgBus.async("InteractionContext.getActiveContext").then((d) => {
                                this.cachingService.email = "";
                                this.msgBus.publish('closed');
                                this.msgBus.async('GenesysSelector.close', 'Overlay').then(() => {
                                    this.msgBus.async("InteractionContext.setActiveContext", d).then(() => {
                                        setTimeout(() => {
                                            this.startChat();
                                        }, 500);
                                    });
                                });
                            });
                            return;
                        }
                    }
                }
            }
            this.track("chat", "chat_ended", "error");
            if (this.activeSession) {
                console.error("Error in WebChatService. Close Chat Session!");
                console.error(eventObject);
                this.endChatSession();
            }
            else {
                this.endChatSession();
            }
        };
        /**
         * Set the state value for a specific key
         *
         * @param stateKey key for specific state
         * @param stateValue value that the state should be assigned to
         *
         * @notice updates local storage
         */
        this.setStateValue = (stateKey, stateValue) => {
            this.state[stateKey] = stateValue;
            this.cachingService.state(this.state);
            this.cachingService.saveCacheSession();
        };
        /**
         * Get state machine for widget application
         */
        this.getStateMachine = () => {
            return this.state;
        };
        /**
         * Returns true if upload for chat session is enabled
         */
        this.canUpload = () => {
            return new Promise((resolve) => {
                this.fileLimitsHelper.isLoaded().then(() => {
                    resolve(this.intObj.getFileLimits().canUpload());
                });
            });
        };
        /**
        * Returns true if upload for chat session is enabled for agents only
        */
        this.canUploadAgentOnly = () => {
            return new Promise((resolve) => {
                this.fileLimitsHelper.isLoaded().then(() => {
                    resolve(this.intObj.getFileLimits().needsAgent());
                });
            });
        };
        /**
         * Saves a message to cache, but does not display it
         * @param htmlObject html formatted string message
         */
        this.saveMessageToCache = (htmlObject) => {
            if (this.state.botConnected) {
                this.cachingService.botMessageContainer.push(htmlObject);
            }
            else {
                this.cachingService.agentMessageContainer.push(htmlObject);
            }
        };
        /**
         * Returns a promise resolves to waiting time in seconds
         *
         * If no waiting time was delivered from the backend, the widget tries to get a waiting time from the interaction context
         */
        this.getWaitingTime = () => {
            return new Promise((resolve, reject) => {
                if (this.cachingService.waitingTime != null) {
                    resolve(this.cachingService.waitingTime);
                }
                else {
                    this.msgBus.async('InteractionContext.getWaitingTime').then((value) => {
                        this.debug && console.log("InteractionContext.getWaitingTime returned ", value);
                        if (value.ewt) {
                            this.cachingService.waitingTime = value.ewt;
                        }
                        else {
                            this.cachingService.waitingTime = 600;
                        }
                        resolve(this.cachingService.waitingTime);
                    }, () => {
                        this.cachingService.waitingTime = 600;
                        resolve(this.cachingService.waitingTime);
                    });
                }
            });
        };
        /**
        * Tracks user interaction
        *
        * @param category this interaction belongs to
        * @param action actual action of the user
        * @param label additional label for the action
        */
        this.track = (category, action, label) => {
            if (Bridge2 && Bridge2.GTMTrack) {
                this.debug ? console.log('Track: Category: ' + category + ' Action: ' + action + ' Label: ' + label) : () => { };
                Bridge2.GTMTrack.track(category, action, label);
            }
        };
        /**
         * Show a system message when the bot enters the chat
         */
        this.showBotJoinedMessage = () => {
            let nick = "A1 Chatbot";
            if (this.configuration.i18n && this.configuration.i18n.chatbotNamePublic) {
                nick = this.configuration.i18n.chatbotNamePublic;
            }
            let message = " hat den Chat betreten.";
            if (this.configuration.i18n && this.configuration.i18n.systemMessageAgentEntered) {
                message = this.configuration.i18n.systemMessageAgentEntered;
            }
            this.uic.createSystemMessage(nick + message);
        };
        /**
         * Show a system message when the bot leaves the chat
         */
        this.showBotLeftMessage = () => {
            // workaround for to show message as last bot message
            this.state.botConnected = true;
            this.uic.setActiveContainer(true);
            let nick = "A1 Chatbot";
            if (this.configuration.i18n && this.configuration.i18n.chatbotNamePublic) {
                nick = this.configuration.i18n.chatbotNamePublic;
            }
            let message = " hat den Chat verlassen.";
            if (this.configuration.i18n && this.configuration.i18n.systemMessageAgentLeft) {
                message = this.configuration.i18n.systemMessageAgentLeft;
            }
            this.uic.createSystemMessage(nick + message);
            this.uic.setActiveContainer(false);
            this.state.botConnected = false;
        };
        /**
         * Show a system message when an agent enters the chat
         *
         * @param agentName to be shown
         */
        this.showAgentJoinedMessage = (agentName) => {
            let nick = "Mitarbeiter";
            if (agentName) {
                nick = agentName;
            }
            let message = " hat den Chat betreten.";
            if (this.configuration.i18n && this.configuration.i18n.systemMessageAgentEntered) {
                message = this.configuration.i18n.systemMessageAgentEntered;
            }
            this.uic.createSystemMessage(nick + message);
        };
        /**
         * Show a system message when an agent leaves the chat
         *
         * @param agentName to be shown
         */
        this.showAgentLeftMessage = (agentName) => {
            let nick = "Mitarbeiter";
            if (agentName) {
                nick = agentName;
            }
            let message = " hat den Chat verlassen.";
            if (this.configuration.i18n && this.configuration.i18n.systemMessageAgentLeft) {
                message = this.configuration.i18n.systemMessageAgentLeft;
            }
            this.uic.createSystemMessage(nick + message);
        };
        /**
         * Send a commmand to the message bus or widget
         * @param commandName
         * @param commandOptions
         */
        this.sendCommand = (commandName, commandOptions) => {
            // Check if interactionManager command 
            if (commandName.startsWith("InteractionManager")) {
                let command = commandName.split("|");
                this.setActiveContext(commandOptions).then(() => {
                    Bridge2.getMessageBus().command(command[0], command[1], commandOptions);
                });
            }
            else if (commandName === "Login") {
                this.uic.activateExtension('login');
            }
            else if (commandName === 'Iframe') {
                this.uic.activateExtension('iframe', commandOptions);
            }
            else {
                CXBus.command(commandName, commandOptions);
            }
        };
        /**
         * Adds default user data to the chat start event
         *
         * @param userData key-value pairs of these object will be added to the userData oject
         */
        this.addDefaultUserData = (userData) => {
            if (userData) {
                for (var k in userData)
                    this.defaultUserData[k] = userData[k];
            }
        };
        /**
         * Set InteractionContext for this conversation
         * @param options object that should contain context attribute in order to set the context
         *
         */
        this.setActiveContext = (options) => {
            return new Promise(function (resolve, reject) {
                if (options && options.context && options.context["context_brand"]) {
                    let newContext = "" + options.context["context_brand"] + ";" + options.context["context_detail"] + ";" + options.context["context_category"] + ";" + options.context["context_demand"] + ";" + options.context["context_sphere"];
                    Bridge2.getMessageBus().async("InteractionContext.setActiveContext", newContext).then(() => {
                        resolve();
                    });
                }
                else {
                    resolve();
                }
            });
        };
        this.version = "v4.2.2";
        this.defaultUserData = {};
        this.name = name;
        this.msgBus = msgBus;
        this.bridge = bridge;
        this.widgetInitialized = false;
        this.handleEvents = true;
        this.uic = new WidgetUIController();
        this.parser = new ChatBotParser();
        this.fileLimitsHelper = new FileLimitsHelper();
        this.messageCollector = [];
        this.cachingService = new CachingService(name, bridge);
        this.cachingService.initCacheSession().then(() => {
            this.state = this.cachingService.loadStateFromCache();
            if (!this.state.mode || this.state.mode == 'sticky') {
                // we initialize with button mode - will be reset by open()
                this.state.mode = "button";
            }
            this.widgetInitialized = true;
            this.createTNPSSurveyFromCache();
            setTimeout(() => {
                // if chat did not start in autoOpen mode after 10s, manually start it - ugly but no other solution - normally this should not happen
                if (!this.activeSession && isInApp()) {
                    this.restartChat(false, true);
                }
            }, 10000);
        });
        window['cw'] = this;
    }
    /**
    * Function is used to provide the widget with an interaction object to receive from and send message to the chatBot
    * @param {*} val Interaction object
    */
    setIntObject(obj) {
        this.debug ? console.log("SET INT OBJECT") : () => { };
        this.intObj = obj;
    }
    /**
     * Installs the configuration object, and sets some values depending on this
     */
    setConfiguration(config) {
        this.configuration = config;
        this.debug = !!this.configuration.debug ? true : false;
        __webpack_public_path__ = config.assetBase + "widgetResources/scripts/";
    }
    /**
     * ACHTUNG: FUNKTION WURDE AM MESSAGE BUS REGISTRIERT, WIRD IM CONTEXT DES PLUGINS AUFGERUFEN
     * Receives Msg Bus Events
     */
    handleMsgBusEvent() {
        let arg = arguments;
        this.debug ? console.log("#############MSGBUSEVENT###########") : () => { };
        this.debug ? console.log(arg) : () => { };
        //filelimits are now known
        if (arg[0] == 'GenesysWebchat.filelimits') {
            this.fileLimitsHelper.setLoaded();
        }
    }
    /**
     * Ends chat technically
     */
    endChat() {
        return new Promise((resolve, reject) => {
            this.intObj.endChat().then(() => {
                this.restored = false;
                this.activeSession = false;
                this.state.agentConnected = false;
                this.state.botConnected = false;
                this.handleEvents = false;
                resolve();
            }).catch(() => {
                reject();
            });
        });
    }
    /**
     * Returns true if no messages are displayed
     */
    isMessageContainerEmpty() {
        return (this.cachingService.botMessageContainer.length == 0 && this.cachingService.agentMessageContainer.length == 0);
    }
    /**
     * Shows a user message in the conversation without sending it
     * @param text text to be shown in
     */
    showUserMessage(text, doNotDisplayOnActiveWidget) {
        let html = this.parser.parseUserInput(text);
        this.addUserMessageToActiveContainer(html);
        let id = this.getWidgetApplicationId();
        if (!id) {
            id = "NOID";
        }
        this.sendCustomNotice(new UserMessageNotice(id, text));
        if (this.state.botConnected) {
            this.uic.chatScreen.showTyping('bot');
        }
    }
    waitForOthersToFinish() {
        let id = Math.random().toString().replace("0.", "");
        this.handleBotInteractionsQueue.push(id);
        return new Promise(resolve => {
            let timeout = () => {
                setTimeout(() => {
                    isMyTurn();
                }, 100);
            };
            let isMyTurn = () => {
                if (this.handleBotInteractionsQueue[0] === id) {
                    resolve();
                }
                else {
                    timeout();
                }
            };
            isMyTurn();
        });
    }
    pause() {
        return new Promise(resolve => {
            let timeout = () => {
                setTimeout(() => {
                    checkPauseEnd();
                }, 100);
            };
            let checkPauseEnd = () => {
                if (Date.now() > this.pauseEnd) {
                    resolve();
                }
                else {
                    timeout();
                }
            };
            checkPauseEnd();
        });
    }
    /**
     * Handle client custom notice messages
     * @param jsonString stringified custom notice object
     */
    handleClientNotice(jsonString) {
        try {
            let clientNotice = JSON.parse(jsonString);
            switch (clientNotice.type) {
                case RequestExecutionRightsNotice.getType():
                    let renotice = clientNotice;
                    if (renotice.callbackId in this.callbackMap) {
                        if (renotice.senderId === this.getWidgetApplicationId()) {
                            this.callbackMap[renotice.callbackId]();
                        }
                        delete this.callbackMap[renotice.callbackId];
                    }
                    break;
                case ScreenChangeNotice.getType():
                    let screenChangeNotice = clientNotice;
                    if (screenChangeNotice.senderId !== this.getWidgetApplicationId()) {
                        this.uic.showScreen(screenChangeNotice.screenName, screenChangeNotice.data);
                    }
                    break;
                case FeedbackOfferNotice.getType():
                    let feedbackOfferNotice = clientNotice;
                    this.state.feedbackOfferGlobal = feedbackOfferNotice.global;
                    break;
                case ExtensionNotice.getType():
                    let extensionNotice = clientNotice;
                    if (extensionNotice.senderId !== this.getWidgetApplicationId()) {
                        if (extensionNotice.onOffSwitch) {
                            this.uic.screenManagement.activateExtension(extensionNotice.name, extensionNotice.options);
                        }
                        else {
                            this.uic.screenManagement.deactivateExtension(extensionNotice.name);
                        }
                    }
            }
        }
        catch (e) {
            //unknown notice
        }
    }
    /**
     * Sends session data object as a notice to genesys
     *
     * @param sessionData
     */
    sendSessionDataAsNotice(sessionData) {
        var secureKeyNotice = new SecureKeyNotice(sessionData['secureKey'], sessionData['alias']);
        this.sendCustomNotice(secureKeyNotice);
    }
    /**
     * Send a custom notice to all participants of the chat
     *
     * @param noticeText stringified object
     */
    sendCustomNotice(notice) {
        return new Promise((resolve, reject) => {
            if (this.intObj) {
                this.intObj.sendCustomNotice(JSON.stringify(notice)).then(() => {
                    resolve();
                }).catch(() => {
                    //Resend Event if failed
                    setTimeout(() => {
                        this.intObj.sendCustomNotice(JSON.stringify(notice)).then(() => {
                            resolve();
                        }).catch(() => {
                            resolve();
                        });
                    }, 2000);
                });
            }
            else {
                resolve();
            }
        });
    }
    /**
     * Returns Widget Application id which is unique for each new instance (new tab)
     */
    getWidgetApplicationId() {
        return this.id;
    }
    /**
     * Creates a new tnps survey from cache
     */
    createTNPSSurveyFromCache() {
        if (this.cachingService.surveyData && this.cachingService.surveyData.hash) {
            let config = {
                apiUrl: this.cachingService.surveyData.apiUrl,
                surveyId: this.cachingService.surveyData.surveyId,
                useProbability: this.cachingService.surveyData.useProbability,
                hash: this.cachingService.surveyData.hash,
                questions: this.cachingService.surveyData.questions
            };
            this.tnpsSurvey = new TNPSSurvey(config);
        }
    }
    createNewTNPSSurvey(config, triggeredFromBot) {
        this.tnpsSurvey = new TNPSSurvey(config);
        this.tnpsSurvey.init().then((result) => {
            if (result && result.show) {
                let data = {
                    feedback: config.feedback,
                    question1: result.question1,
                    question2: result.question2,
                    questions: result.questions,
                    hash: result.hash,
                    apiUrl: config.apiUrl,
                    surveyId: config.surveyId,
                    useProbability: config.useProbability
                };
                this.sendCustomNotice(new TrackingNotice("chat", "TNPS_screen_view", "TNPS_screen_view"));
                let screenChangeNotice = new ScreenChangeNotice("tnps", undefined, data);
                this.sendCustomNotice(screenChangeNotice);
            }
            else {
                if (!triggeredFromBot || !this.configuration.surveySettings.disableThankYouScreen) {
                    this.sendCustomNotice(new ScreenChangeNotice("thankyou"));
                }
                else {
                    this.sendCustomNotice(new ScreenChangeNotice("chat"));
                }
                let event = TNPSSurvey.createCustomNoticeEvent(null, null, null, false, false, null);
                this.sendCustomNotice(event);
            }
        }).catch((error) => {
            if (!triggeredFromBot || !this.configuration.surveySettings.disableThankYouScreen) {
                this.sendCustomNotice(new ScreenChangeNotice("thankyou"));
            }
            else {
                this.sendCustomNotice(new ScreenChangeNotice("chat"));
            }
            let tnpsError = error;
            if (tnpsError.status == 422) {
                let event = new TrackingNotice("chat", " TNPS_Quarantine", " TNPS_Quarantine");
                this.sendCustomNotice(event);
            }
            else {
                let event = TNPSSurvey.createCustomNoticeEvent(null, null, null, false, false, "Error initializing survey: " + tnpsError.error + " userAgent: " + window.navigator.userAgent);
                this.sendCustomNotice(event);
            }
        });
    }
    /**
     * Silently restarts a chat session without the user noticing it
     */
    silentlyRestartChatSession() {
        return new Promise((resolve, reject) => {
            let startChat = () => {
                this.track("chat", "chat_start", "new_question");
                this.msgBus.publish('closed');
                this.cachingService.softReset();
                this.uic.resetContent();
                setTimeout(() => {
                    this.restartChat(true).then(() => resolve()).catch(() => reject());
                }, 2000);
            };
            this.endChat().then(() => {
                startChat();
            }).catch(() => {
                startChat();
            });
        });
    }
    restartChat(newQuestion, autoOpen) {
        return new Promise((resolve, reject) => {
            let channelEntry;
            let context_brand = "A1", context_category = "Allgemein", context_demand = "Allgemein", context_detail = "Privat", context_sphere = "";
            if (this.cachingService.userData) {
                if (this.cachingService.userData.last) {
                    channelEntry = this.cachingService.userData.last.channelEntry;
                    context_brand = this.cachingService.userData.last.context_brand;
                    context_category = this.cachingService.userData.last.context_category;
                    context_demand = this.cachingService.userData.last.context_demand;
                    context_detail = this.cachingService.userData.last.context_detail;
                    context_sphere = this.cachingService.userData.last.context_sphere;
                }
                if (this.cachingService.userData.value) {
                    channelEntry = this.cachingService.userData.value.channelEntry;
                    context_brand = this.cachingService.userData.value.context_brand;
                    context_category = this.cachingService.userData.value.context_category;
                    context_demand = this.cachingService.userData.value.context_demand;
                    context_detail = this.cachingService.userData.value.context_detail;
                    context_sphere = this.cachingService.userData.value.context_sphere;
                }
            }
            if (!channelEntry) {
                channelEntry = this.defaultChannelEntry;
            }
            if (!this.cachingService.firstname)
                this.cachingService.firstname = "Anonymous";
            if (!this.cachingService.lastname)
                this.cachingService.lastname = "Anonymous";
            let contextString = context_brand + ";" + context_detail + ";" + context_category + ";" + context_demand + ";" + context_sphere;
            this.msgBus.async('InteractionContext.startContext', contextString, { action: "chat", new_question: newQuestion, anon: autoOpen, custom: { channelEntry: channelEntry } });
            resolve();
        });
    }
    saveChatStartTimestamp() {
        this.cachingService.chatStartTimestamp = new Date();
    }
    subscribeToRestoreEvent(callback) {
        this.restoreCallbacks.push(callback);
    }
}
